@if (workflowSteps.length > 0) {
    <cerrix-workflow-bar [steps]="workflowSteps"></cerrix-workflow-bar>
}
<app-cerrix-breadcrumb [crumbs]="breadcrumbs"></app-cerrix-breadcrumb>
<div class="name-and-instructions-container">
    @if (edit) {
        <div class="asset-name-field-wrapper">
            <input
                class="asset-name-field"
                [(value)]="title"
                (input)="titleChange.emit($event.target.value)"
                required
            />
            @if (!title) {
                <span class="placeholder-overlay"
                    >{{ titlePlaceholder }} <span class="required">*</span></span
                >
            }
        </div>
    } @else {
        <cerrix-title [text]="title"></cerrix-title>
    }
</div>
